import { render, staticRenderFns } from "./AddNewRecipient.vue?vue&type=template&id=a858dbf4&scoped=true"
import script from "./AddNewRecipient.vue?vue&type=script&lang=js"
export * from "./AddNewRecipient.vue?vue&type=script&lang=js"
import style0 from "./AddNewRecipient.vue?vue&type=style&index=0&id=a858dbf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a858dbf4",
  null
  
)

export default component.exports